window.originFetch = fetch;
if (!customElements.get("apply-discount-code")) {
  customElements.define(
    "apply-discount-code",
    class ApplyDiscountCode extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector("[data-input-code]"),
          applyButton: this.querySelector("[data-apply-button]"),
          hintCode: this.querySelector("[data-hint-code]"),
        };
        this.cartItems = document.querySelectorAll("cart-items");

        this.initEvent();
      }

      initEvent() {
        this.elements.applyButton.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.elements.input.value.trim() === "") {
            for (const component of this.components) {
              component.elements.input.value = "";
            }
            this.elements.input.focus(); // Focus on the input field
            this.elements.input.setCustomValidity(""); // Reset any previous custom validity message
            this.elements.input.reportValidity(); // Trigger the browser's validation message
          } else {
            this.submit(this.elements.input.value);
          }
        });
        this.elements.input.addEventListener("input", () => {
          if (this.classList.contains("loading")) return false;
          const value = this.elements.input.value;
          for (const component of this.components) {
            if (component != this) component.elements.input.value = value;
            component.classList.remove("failed");
            component.elements.applyButton.classList.remove("failed");
            component.elements.hintCode.innerHTML = this.elements.input.value;
          }
        });
        this.elements.input.addEventListener("keydown", (e) => {
          if (e.keyCode === 13) {
            this.elements.applyButton.click();
          }
        });
      }

      async submit(code) {
        this.startLoading();
        const redirect = encodeURIComponent(`${Shopify.routes.root}cart`);
        return originFetch(
          `${Shopify.routes.root}discount/${code}?redirect=${redirect}`
        )
          .then((res) => {
            return res.text();
          })
          .then(async (res) => {
            const html = new DOMParser().parseFromString(res, "text/html");
            const discountElement = html.querySelector("apply-discount-code");
            const discounts = discountElement
              .getAttribute("data-discounts")
              .split(",")
              .map((v) => v.trim().toLowerCase());
            console.log("discounts", discounts, "code", code);
            const codeLowerCase = code.toLowerCase();
            if (discounts.includes(codeLowerCase)) {
              // 折扣码有效
              //   publish(PUB_SUB_EVENTS.cartReload);
              this.notifySuccess();
              for (const component of this.components) {
                component.elements.input.value = "";
              }
              ajaxCart?.load()
            } else {
              // 折扣码无效
              //   publish(PUB_SUB_EVENTS.cartReload);
              this.notifyFailed();
            }
          })
          .finally(() => {
            this.finishLoading();
          });
      }

      get components() {
        return document.querySelectorAll("apply-discount-code");
      }

      /** 应用成功通知 */
      notifySuccess() {
        for (const component of this.components) {
          component.classList.remove("failed");
          component.elements.applyButton.classList.remove("failed");
          component.classList.add("success");
          component.elements.applyButton.classList.add("success");
        }
        setTimeout(() => {
          for (const component of this.components) {
            component.classList.remove("success");
            component.elements.applyButton.classList.remove("success");
          }
        }, 3000);
      }

      /** 应用失败通知 */
      notifyFailed() {
        for (const component of this.components) {
          component.classList.add("failed");
          component.elements.applyButton.classList.add("failed");
        }
      }

      startLoading() {
        this.cartItems.forEach((items) => items.enableLoading());
        for (const component of this.components) {
          component.classList.add("loading");
          component.elements.input.setAttribute("disabled", "");
          component.elements.applyButton.classList.add("loading");
        }
      }

      finishLoading() {
        this.cartItems.forEach((items) => items.disableLoading());
        for (const component of this.components) {
          component.classList.remove("loading");
          component.elements.input.removeAttribute("disabled");
          component.elements.applyButton.classList.remove("loading");
        }
      }
    }
  );
}

if (!customElements.get("cart-discount-copy")) {
  customElements.define(
    "cart-discount-copy",
    class CartDiscountCopy extends HTMLElement {
      constructor() {
        super();
      }
      get code() {
        return this.dataset.code;
      }
      connectedCallback() {
        this.addEventListener("click", (e) => {
          e.preventDefault();
          navigator.clipboard.writeText(this.code);
          this.classList.add("copied");
          setTimeout(() => {
            this.classList.remove("copied");
          }, 3000);
        });
      }
    }
  );
}
if (!customElements.get("upsell-action")) {
  customElements.define(
    "upsell-action",
    class UpsellAction extends HTMLElement {
      constructor() {
        super();
        this.atc = this.querySelector(".ajaxcart-upsell-item-atc");
      }
      get id() {
        return this.querySelector("select")?.value ? this.querySelector("select").value - 0 : this.dataset.id;
      }
      connectedCallback() {
        this.atc.addEventListener("click", (e) => {
          let formData = {
            items: [
              {
                id: this.id,
                quantity: 1,
              },
            ],
          };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              ajaxCart.load();
              return response.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        });
      }
    }
  );
}
if (!customElements.get("help-icon")) {
  customElements.define(
    "help-icon",
    class HelpIcon extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.modalOverlay = document.getElementById("modalOverlay");
        this.closeBtn = document.getElementById("closeBtn");
        this.addEventListener("click", () => {
          modalOverlay.classList.add("active");
        });
        this.closeBtn.addEventListener("click", () => {
          this.modalOverlay.classList.remove("active");
        });
        this.modalOverlay.addEventListener("click", (e) => {
          if (e.target === this.modalOverlay) {
            this.modalOverlay.classList.remove("active");
          }
        });
        document.addEventListener("keydown", function (e) {
          if (
            e.key === "Escape" &&
            this.modalOverlay.classList.contains("active")
          ) {
            this.modalOverlay.classList.remove("active");
          }
        });
      }
    }
  );
}
// // 获取DOM元素
// const helpIcon = document.getElementById("helpIcon");
// const modalOverlay = document.getElementById("modalOverlay");
// const closeBtn = document.getElementById("closeBtn");

// // 点击问号图标打开弹窗
// helpIcon.addEventListener("click", function () {
//   modalOverlay.classList.add("active");
// });

// // 点击关闭按钮关闭弹窗
// closeBtn.addEventListener("click", function () {
//   modalOverlay.classList.remove("active");
// });

// // 点击弹窗外部区域关闭弹窗
// modalOverlay.addEventListener("click", function (e) {
//   if (e.target === modalOverlay) {
//     modalOverlay.classList.remove("active");
//   }
// });

// // 按ESC键关闭弹窗
// document.addEventListener("keydown", function (e) {
//   if (e.key === "Escape" && modalOverlay.classList.contains("active")) {
//     modalOverlay.classList.remove("active");
//   }
// });
